<template>
     <div class="container-fluid">
         <div class="row">
            <div class="col-lg-8 col-md-12">
               <div class="card">
                  <div class="card-header d-flex justify-content-between">
                     <div class="header-title">
                        <h4 class="card-title">Edit News</h4>
                     </div>
                  </div>
                  <div class="card-body">
                     <form>
                        <div class="form-group group mb-3 pb-1">
                           <label for="name"><bold class="asterik">* </bold> Name:</label>
                           <b-form-input style="width: 70%;" type="text" id="name" placeholder="Name" :class="`form-control ${$v.newsForm.name.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.name" @input="$v.newsForm.name.$touch()" @blur="$v.newsForm.name.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="name">Game Code:</label>
                           <b-form-input style="width: 70%;" type="text" id="gameCode" placeholder="Game Code"
                              v-model="newsForm.game_code" @input="$v.newsForm.game_code.$touch()" @blur="$v.newsForm.game_code.$touch()">
                           </b-form-input>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="title"><bold class="asterik">* </bold> Title:</label>
                           <b-form-input type="text" id="title" placeholder="Title" :class="`form-control ${$v.newsForm.title.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.title" @input="$v.newsForm.title.$touch()" @blur="$v.newsForm.title.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="short_description"><bold class="asterik">* </bold> Short Description:</label>
                           <b-form-textarea id="short_description" placeholder="Short _description." :class="`form-control ${$v.newsForm.short_description.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.short_description" @input="$v.newsForm.short_description.$touch()" @blur="$v.newsForm.short_description.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="long_description"><bold class="asterik">* </bold> Long Description:</label>
                           <b-form-textarea id="long_description" placeholder="Long _description." size="lg" :class="`form-control ${$v.newsForm.long_description.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.long_description" @input="$v.newsForm.long_description.$touch()" @blur="$v.newsForm.long_description.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="image"><bold class="asterik">* </bold> Image</label>
                           <input type="file" name="image" class="form-control-file" id="picture" @change="onFileChange">
                        </div>

                        <img v-bind:src="imagePreview" width="50%" height="100%" style="margin-bottom: 35px;" v-show="showPreview"/>
                        <br>

                        <div class="form-group group mb-3 pb-1">
                           <label for="start_date"><bold class="asterik">* </bold> Start Date:</label>
                           <b-form-datepicker style="width: 70%;" id="start_date" v-model="newsForm.start_date" :class="`form-control ${$v.newsForm.start_date.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.start_date.$touch()" @blur="$v.newsForm.start_date.$touch()" required></b-form-datepicker>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="end_date"><bold class="asterik">* </bold> End Date:</label>
                           <b-form-datepicker style="width: 70%;" id="end_date" v-model="newsForm.end_date" :class="`form-control ${$v.newsForm.end_date.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.end_date.$touch()" @blur="$v.newsForm.end_date.$touch()" required></b-form-datepicker>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="category"><bold class="asterik">* </bold> Category:</label>
                           <b-form-select style= "width: 20% ; margin-left: 30px;" id="category" v-model="newsForm.category" :class="`${$v.newsForm.category.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.category.$touch()" @blur="$v.newsForm.category.$touch()" :options="category" required ></b-form-select>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1" v-if="newsForm.category != ''">
                           <label for="countdown"><bold class="asterik">* </bold>Type:</label>
                           <b-form-checkbox-group id="newsType" v-model="type" :options="newsType" value-field="value" required></b-form-checkbox-group>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="countdown"><bold class="asterik">* </bold> Countdown:</label>
                           <section>
                              <input type="radio" v-model="newsForm.countdown" value="1"> Yes
                              <input type="radio" v-model="newsForm.countdown" value="0"> No
                           </section>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                     </form>

                     <div class="col-md-12 form-group">
                        <button type="button" class="btn btn-primary float-right" v-on:click="register">Add</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
</template>

<style>
   .group {
      display: inline-block;
      width: calc(52% - 1.5em);
      padding-top: 20px;
   }
    .asterik{
      color:red
   }

  
</style>

<script>

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const config = require("../../../../../config");
const constants = require("../../../../constants/CommonConstants");


Vue.use(VueAxios, axios)


export default {
   name:'NewsEdit',
   data() {
      return {
         newsForm: {
            name: '',
            title:'',
            short_description: '',
            long_description: '',
            image:'',
            imagename: '',
            category: '',
            start_date:'',
            end_date:'',
            countdown:'',
            game_code:'',
            update_by:''          
         },
         imagePreview: null,
         showPreview: true,
         category: constants.newsCategory,
         countdown: constants.countdown,
         newsType: constants.newsType,
         type:[],
         cat:'',   
      }   
   },

   mixins: [validationMixin],
   validations: {
      newsForm: { 
         name: { required },
         title: { required },
         short_description: { required },
         long_description: { required },
         category: { required },
         start_date:{ required },
         end_date:{ required },
         countdown: { required },   
      }
   },
    mounted: async function() {
      try {
         const res = await axios.get(config.api.URL + '/api/news/get', {
            params: {
               m: this.$route.meta.uid,
               id: this.$route.query.id 
            }
         });
         
         if (res.data.news_list.countdown === false) {
            res.data.news_list.countdown = 0
         } else {
            res.data.news_list.countdown = 1
         }
         
         this.newsForm = res.data.news_list;
         this.imagePreview = config.api.URL + res.data.news_list.image

        
         var cat = res.data.news_list.category.split(',')
         console.log(cat)

         cat.forEach(element => {

            if (element === 'ARCADE' || element === 'SLOT') {
            this.newsForm.category = element
            
         } else {
            this.type.push(element)
         }
            
         });
            
        
      } catch(error) {
         alert("Error: Unable to retrieve data");
         console.log("Error: ", error)
      }
   },
   
   methods: {
    register: async function() {
         try {
            this.$v.$touch();
            var user = JSON.parse(localStorage.getItem("user"));
            let id = this.$route.query.id
            var categories = []

            categories.push(this.newsForm.category)
   
            this.type.forEach(element => {
               categories.push(element)
            });

            this.newsForm.category = categories.join();

            if(!this.$v.$invalid && confirm("Are you sure you want to update this news?")) {
                this.newsForm.updated_by = user.username
               await axios.post(config.api.URL + '/api/news/edit', this.newsForm, { params: {id: id, m: this.$route.meta.uid } });
               
               alert("news is updated successfully.");
               this.$router.push({path: '/news/list'});
            }
         } catch(error) {
            alert("Error!")
            console.log("error", error)
         }
      },
      onFileChange(event){
         this.newsForm.image = event.target.files[0];
         // console.log(this.news.image)
         this.newsForm.imagename = this.newsForm.image.name

         let reader  = new FileReader();
        
         let rawImg;
         reader.onloadend = () => {
            rawImg = reader.result;
            this.newsForm.image = rawImg
            console.log(rawImg)
         }

         reader.addEventListener("load", function () {
            this.showPreview = true;
            this.imagePreview = reader.result;
         }.bind(this), false);

         if( this.newsForm.image ){
            if ( /\.(jpe?g|png|gif)$/i.test( this.newsForm.image.name ) ) {
                  reader.readAsDataURL( this.newsForm.image);
            } else{
               alert("Invalid image format")
            }
         }
      }
   }
}
</script>